import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Save, Plus, X, User } from "lucide-react";
import { IconTextButton } from "../../../components/ButtonComponents";
import { Employee, EmployeePayload } from "../../../types/employee";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    employee: Employee | null;
    onSave: (data: EmployeePayload) => void;
}

export const EmployeeDialog: React.FC<Props> = ({ isOpen, onClose, employee, onSave }) => {
    const [formData, setFormData] = useState<EmployeePayload>({
        externalId: "",
        firstName: "",
        lastName: "",
        isActive: true
    });

    useEffect(() => {
        if (isOpen) {
            if (employee) {
                setFormData({
                    externalId: employee.externalId || "",
                    firstName: employee.firstName || "",
                    lastName: employee.lastName || "",
                    isActive: employee.isActive
                });
            } else {
                setFormData({ 
                    externalId: "", 
                    firstName: "", 
                    lastName: "", 
                    isActive: true 
                });
            }
        }
    }, [employee, isOpen]);

  const handleSubmit = () => {
        if (!formData.externalId || !formData.firstName) {
            return;
        }

        // DÜZELTME BURADA:
        if (employee) {
            // Güncelleme yaparken externalId'yi paketten çıkarıyoruz
            // Böylece Backend'deki "excess property" hatasına takılmıyoruz
            const { externalId, ...updatePayload } = formData;
            onSave(updatePayload as any); 
        } else {
            // Yeni kayıt oluştururken externalId zorunlu olduğu için olduğu gibi gönderiyoruz
            onSave(formData);
        }
    };

    return (
        <Dialog 
            header={
                <div className="flex items-center gap-2">
                    <User className="w-5 h-5 text-blue-600" />
                    <span>{employee ? "Personel Düzenle" : "Yeni Personel Ekle"}</span>
                </div>
            }
            visible={isOpen} 
            onHide={onClose}
            className="w-full md:w-4/12 lg:w-3/12"
            modal
            footer={
                <div className="flex justify-end gap-2">
                    <IconTextButton onClick={onClose} icon={X} className="btn-cancel">İptal</IconTextButton>
                    <IconTextButton onClick={handleSubmit} icon={employee ? Save : Plus} className="btn-new">
                        {employee ? "Güncelle" : "Personel Ekle"}
                    </IconTextButton>
                </div>
            }
        >
            <div className="flex flex-col gap-4 p-2">
                {/* Mikro Kodu */}
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold"> Personel Kodu</label>
                    <InputText 
                        value={formData.externalId} 
                        onChange={(e) => setFormData({...formData, externalId: e.target.value})} 
                        placeholder="Örn: P001"
                        disabled={!!employee} // Düzenlemede kod genelde değiştirilmez
                    />
                </div>

                {/* Ad */}
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold">Ad</label>
                    <InputText 
                        value={formData.firstName} 
                        onChange={(e) => setFormData({...formData, firstName: e.target.value})} 
                        placeholder="Personel Adı"
                    />
                </div>
                
                {/* Soyad */}
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold">Soyad</label>
                    <InputText 
                        value={formData.lastName} 
                        onChange={(e) => setFormData({...formData, lastName: e.target.value})} 
                        placeholder="Personel Soyadı"
                    />
                </div>

                {/* Aktiflik Durumu */}
                <div className="flex items-center gap-2 mt-2">
                    <Checkbox 
                        inputId="isActive" 
                        checked={!!formData.isActive} 
                        onChange={(e) => setFormData({...formData, isActive: !!e.checked})} 
                    />
                    <label htmlFor="isActive" className="text-sm font-semibold cursor-pointer">Personel Çalışmaya Devam Ediyor</label>
                </div>
            </div>
        </Dialog>
    );
};